import proxyInstance from "src/config/api/proxyInstance";

interface signUpForNewsProps {
  email: string;
}

export const signUpForNews = (params: signUpForNewsProps) =>
  proxyInstance.get("/users/sign_up_for_news", { params });
